import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

let device;

if (window.screen.width >= 1350) {
  device = "desktop";
}
if (window.screen.width >= 1025 && window.screen.width < 1350) {
  device = "largeTablet";
}
if (window.screen.width >= 738 && window.screen.width < 1024) {
  device = "tablet";
}
if (window.screen.width <= 737) {
  device = "mobile";
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1350 },
    items: 4,
    slidesToSlide: 4, // optional, default to 1.
  },
  largeTablet: {
    breakpoint: { max: 1349, min: 1025 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 738 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 737, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const PageCarousel = (props) => {
  return (
    <div className="col-10 ">
      <Carousel
        swipeable={false}
        draggable={device === "desktop" ? false : true}
        showDots={false}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={false}
        autoPlay={false}
        keyBoardControl={true}
        // customTransition="all .5"
        // centerMode={true}
        transitionDuration={500}
        containerClass="carousel-container"
        // removeArrowOnDeviceType={["tablet", "mobile"]}
        deviceType={device}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        {props.children}
      </Carousel>
    </div>
  );
};

export default PageCarousel;
